<template>
  <div class="mapWrapper">
    <div id="mapContainer" class="mapContainer" ref="map"></div>
    <div class="toolbar">
      <div class="t">
        <div class="title">测试结果</div>
        <div class="content">
          <p :class="eventList.length ? eventList[eventList.length - 1].type : ''">{{ eventList.length ? eventList[eventList.length - 1].msg : '暂无内容' }}</p>
        </div>
      </div>
      <div class="c">
        <div class="title">位置信息</div>
        <div class="content">
          <p>
            <label>经度</label>
            <el-input v-model="settlePosition[0]" type="number" readonly />
          </p>
          <p>
            <label>纬度</label>
            <el-input v-model="settlePosition[1]" type="number" readonly />
          </p>
          <p>
            <span @click="clearSettleLocation">清除</span>
            <span class="disabledBtn">自动定位</span>
            <span class="blueBtn" @click="toSettleLocation">手动定位</span>
          </p>
        </div>
      </div>
      <div class="b">
        <div class="title">围栏信息</div>
        <div class="content">
          <template v-if="fenceInfo">
            <p>
              <el-radio v-model="fenceInfo.type" label="1" :disabled="mode === 'drawing'" @change="changeType">圆形&emsp;</el-radio>
              <el-radio v-model="fenceInfo.type" label="2" :disabled="mode === 'drawing'" @change="changeType">多边形</el-radio>
            </p>
            <p>
              <label>{{fenceInfo.type === '1' ? "半径值" : "点位数"}}</label>
              <el-input v-if="fenceInfo.type === '1'" v-model="fenceInfo.radius" type="number" min="5" max="99999" :disabled="mode === 'drawing'" placeholder="请输入半径值" />
              <el-input v-if="fenceInfo.type === '2'" v-model="fenceInfo.dotNum" type="number" min="3" max="20" :disabled="mode === 'drawing'" placeholder="请输入点位数" />
            </p>
            <p>
              <span @click="clearEdit" :class="[(mode === 'drawing' || (!circle && !polygon)) ? 'disabledBtn' : '']">清空</span>
              <span @click="startEdit" :class="[(mode === 'drawing' || circle || polygon) ? 'disabledBtn' : 'greenBtn']">开始编辑</span>
            </p>
          </template>
          <p v-else><span class="blueBtn" @click="toAddFence">添加围栏</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    mode: {
      handler(n, o) {
        // 由 drawing 变更为其他模式时
        // 认为编辑围栏动作已经结束
        // 有手动结束和自动结束
        if (o === 'drawing') {
          let that = this
          let editType = that.fenceInfo.type
          if (editType === '1') {
            that.circle = new AMap.Circle({
                map: that.map,
                center: that.fenceInfo.dotList[0],
                radius: that.fenceInfo.radius,
                strokeWeight: 0,
                fillOpacity: 0.4,
                // 线样式还支持 'dashed'
                fillColor: '#1791fc',
                zIndex: 50
              })
            that.circle.on('click', that.addMarker)
          } else if (editType === '2') {
            that.polygon = new AMap.Polygon({
              map: that.map,
              fillOpacity: 0.4,
              path: that.fenceInfo.dotList,
              strokeWeight: 0
            })
            that.polygon.on('click', that.addMarker)
          }
          that.map.setFitView()
        }
      }
    }
  },
  data() {
    return {
      map: undefined,
      // default edit drawing local
      mode: 'default',
      fenceInfo: undefined,
      circle: undefined,
      polygon: undefined,
      markerList: [],
      eventList: [],
      settlePosition: [0, 0],
      settleMarker: undefined
    }
  },
  methods: {
    initMap() {
      let map = new AMap.Map('mapContainer', {
        layers: [new AMap.TileLayer.Satellite(), new AMap.TileLayer.RoadNet()],
        resizeEnable: true,
        zoom: 15
      })
      map.on('click', this.addMarker)
      this.map = map
    },
    toAddFence() {
      this.fenceInfo = {
        type: '1',
        radius: 5,
        dotNum: 1,
        dotList: []
      }
      this.mode = 'edit'
    },
    startEdit() {
      // 在编辑围栏中，不操作
      if (this.mode === 'drawing') return
      if (this.fenceInfo.type === '1') {
        if (this.fenceInfo.radius < 5) {
          this.fenceInfo.radius = 5
          this.eventList.push({type: 'warning', msg: "圆形围栏半径不能小于5m"})
          return
        }
        if (this.fenceInfo.radius > 10000) {
          this.fenceInfo.radius = 10000
          this.eventList.push({type: 'warning', msg: "圆形围栏半径不能大于10000m"})
          return
        }
      } else {
        if (this.fenceInfo.dotNum < 3) {
          this.fenceInfo.dotNum = 3
          this.eventList.push({type: 'warning', msg: "多边形围栏点位数不能少于3个"})
          return
        }
        if (this.fenceInfo.dotNum > 20) {
          this.fenceInfo.dotNum = 20
          this.eventList.push({type: 'warning', msg: "多边形围栏点位数不能多于20个"})
          return
        }
      }
      // 开始编辑，先判断是否已经存在围栏
      if ((this.fenceInfo && this.fenceInfo.dotList.length) || this.circle || this.polygon) {
        this.eventList.push({type: 'warning', msg: "已存在围栏信息，请先清空"})
        return
      }
      this.mode = 'drawing'
      let msg = "开始编辑围栏信息，满足条件时，将会自动结束编辑！"
      if (this.fenceInfo.type === '2') msg += "当前为多边形电子围栏，请按顺序添加点位！"
      this.eventList.push({type: 'info', msg })
    },
    clearEdit() {
      if (this.mode !== 'drawing') {
        this.mode = 'edit'
        this.eventList.push({type: 'info', msg: "清空围栏信息"})
        // 地图清空围栏
        this.map.clearMap()
        this.fenceInfo.dotList = []
        this.markerList = []
        this.circle = undefined
        this.polygon = undefined
      }
    },
    changeType(t) {
      if (t === '1') {
        this.fenceInfo.dotNum = 1
      } else {
        this.fenceInfo.dotNum = 3
      }
    },
    toSettleLocation() {
      if (this.circle || this.polygon) {
        this.mode = 'local'
        this.eventList.push({type: 'info', msg: "开始手动设置点位"})
      } else {
        this.eventList.push({type: 'warning', msg: "还未设置围栏信息"})
      }
    },
    clearSettleLocation() {
      if (this.settleMarker) {
        this.settleMarker.setMap(null)
        this.settleMarker = undefined
        this.eventList.push({type: 'info', msg: '清除了点位'})
      }
    },
    addMarker(ev) {
      let m = this.mode
      let lnglat = ev.lnglat
      let pos = [lnglat.lng, lnglat.lat]
      let that = this
      if (m === 'drawing') {
        that.fenceInfo.dotList.push(pos)
        let marker = new AMap.Marker({
          map: that.map,
          position: pos
        })
        that.markerList.push(marker)
        that.map.setFitView()
        if (that.fenceInfo.dotNum * 1 === that.fenceInfo.dotList.length) {
          that.eventList.push({type: 'info', msg: "点位数已满足，将自动结束编辑"})
          setTimeout(() => {
            that.mode = 'edit'
          }, 500)
        }
      } else if (m === 'local') {
        this.settlePosition = pos
        if (that.settleMarker) {
          that.settleMarker.setMap(null)
          that.settleMarker = undefined
        }
        let tempMarker = new AMap.Marker({
          draggable: true,
          position: pos
        })
        tempMarker.on('dragend', that.addMarker)
        tempMarker.setMap(that.map)
        that.settleMarker = tempMarker
        let target = ev.target
        if (target.CLASS_NAME && (target.CLASS_NAME === 'AMap.Circle' || target.CLASS_NAME === 'AMap.Polygon')) {
          that.eventList.push({type: 'success', msg: "点位在电子围栏区域内"})
        } else {
          let f = that.circle ? that.circle.contains(pos) : that.polygon ? that.polygon.contains(pos) : false
          if (f) that.eventList.push({type: 'success', msg: "点位在电子围栏区域内"})
          else that.eventList.push({type: 'error', msg: "点位不在电子围栏区域内"})
        }
        that.map.setFitView()
      } else {
       this.eventList.push({type: 'warning', msg: "请先选择你要执行的操作"})
      }
    }
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    if (this.map) this.map.destroy()
  }
}
</script>

<style lang="less" scoped>
.mapWrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  .mapContainer {
    width: 100%;
    height: 100%;
    /deep/ .amap-logo {
      display: none;
      opacity: 0 !important;
    }
    /deep/ .amap-copyright {
      opacity: 0;
    }
  }
  .toolbar {
    width: 300px;
    height: 90%;
    display: flex;
    border-radius: 10px;
    flex-flow: column nowrap;
    justify-content: space-evenly;
    background: rgba(12, 47, 69, 0.21);
    position: absolute;
    top: 5%;
    right: 10px;
    overflow: hidden;
    > div {
      width: 100%;
      display: flex;
      flex-flow: column nowrap;
      flex-grow: 1;
      height: 33%;
      .title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: left;
        padding: 0 10px;
        background: #0c2f45;
        color: #999;
        font-weight: bold;
      }
      .content {
        flex-grow: 1;
        margin: 0;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        color: #ddd;
        text-align: center;
        p {
          margin: 10px 0;
          label {
            margin: 0 5px;
          }
          .el-input {
            width: 60%;
            /deep/ input {
              height: 36px;
              background: rgba(0, 0, 0, 0.38);
              border: 0;
              border-bottom: 1px solid rgba(221, 221, 221, 0.21);
              color: #f5f5f5;
              border-radius: 2px;
            }
            /deep/ input:focus {
              border-bottom: 1px solid rgba(221, 221, 221, 0.63);
            }
          }
        }
        p.success {
          color: #0dd78d !important;
        }
        p.error {
          color: #ff1e1e !important;
        }
        p.warning {
          color: #ffbb1f !important;
        }
        p:last-child {
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          text-align: center;
          span {
            display: inline-block;
            padding: 5px 10px;
            margin: 0 10px;
            border-radius: 4px;
            cursor: pointer;
            background: #fff;
            color: #333;
            font-size: 12px;
          }
          span:not(.disabledBtn):hover {
            transform: scale(1.1);
          }
          span.blueBtn {
            background: #306ac9 !important;
            color: #fff !important;
          }
          span.greenBtn {
            background: #0dd78d !important;
            color: #fff !important;
          }
          span.disabledBtn {
            background: #ccc !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exhibitionHall/electronicFence/index.vue